export function scrollToTop() {
    window.scrollTo(0, 0)
    document.querySelector("#app-body").scrollTo(0,0);
}